<template src="./media-thumb.html"></template>

<script lang="ts">
import { getImageUrl } from 'util/media-utils'
import mediaMixin from './MediaMixin.vue'

export default {
  data() {
    return {
      isImageLoaded: false,
      // MediaThumb and MediaSubmissionThumb both use the same html file, this is used to
      // specify the lazy loading of the image, which in this case should always be true
      useLazy: true
    }
  },
  props: {
    altText: String
  },
  mixins: [mediaMixin],
  computed: {
    imageStyles() {
      // if one side of the image is less than size (160 or 320), then need to calculate
      // pan & zoom dimensions
      if (this.isImage &&
          !(this.media.width < this.imgThumbSize || this.media.height < this.imgThumbSize)) {
        // even though thumbnails are square, need to explicitly set width and height due to
        // differences in how IE interprets max-width 100% compared to other browsers.
        return this.itemStyles + (!this.isImageLoaded ? 'opacity: 0;' : '')
      }
      const dims = this.getPanAndZoomDimensions(
        this.isImage ? this.media.width : this.media.thumbnailWidth,
        this.isImage ? this.media.height : this.media.thumbnailHeight,
        this.size,
        this.size
      )
      const newWidth = dims.width
      const newHeight = dims.height
      // we need to adjust the top or left to fit in the square
      const { top, left } = this.getImagePositioning(newWidth, newHeight, this.size, this.size)
      const allStyles = {
        width: newWidth,
        height: newHeight,
        top,
        left,
        opacity: this.isImageLoaded ? 1 : 0
      }
      return this.getStyleString(allStyles)
    },
    itemStyles() {
      return this.getStyleString({ width: this.size, height: this.size })
    },
    imageSrc() {
      if (this.isImage) {
        return getImageUrl(this.media, `PZ${this.imgThumbSize}`)
      }
      return this.media.thumbnailUrl // video
    },
    imgThumbSize() {
      return 320
      // which to use? PZ160 or PZ320.  Only returning pixel portion for calculation purposes
      /* Temporarily disable until after release so all current images can have the 160
         size added.
      if (this.size > 160) {
        return 320
      }
      return (window.devicePixelRatio || 1) > 1 ? 320 : 160
      */
    }
  },
  methods: {
    onImageLoad() {
      this.isImageLoaded = true
    }
  }
}
</script>

<style lang="scss" src="./media-thumb.scss"></style>
